import {defineStore} from 'pinia';
import {drivers as getDriversService} from '@/services/adminService';

export const useAdminStore = defineStore('admin', {
    actions: {
        async drivers(page = 1, limit = 10) {
            try {
                return await getDriversService(page, limit);
            } catch (error) {
                console.error('Error al obtener los drivers', error);
                throw error; // Rethrow to handle in the component
            }
        },
    },
});